import React from 'react';
import { NotFoundError } from '../../../../errors/not-found-error';
import { getAggregatedTitleImage } from '../../../../queries/ats/common';
import { ErrorBoundary } from '../../../error-boundary';
import { usePlay } from '../../hooks/use-play';
import { PlayerErrorFallback } from '../player-error-fallback/player-error-fallback';
import { PlayerLoadingSpinner } from '../player-loading-spinner';
import { TrailerPlayer } from './trailer-player';

interface TrailerPlayerLoaderProps {
  platformTitleId: string;
  providerIdentifier: string;
  position: number | undefined;
}

export function TrailerPlayerLoader({ platformTitleId, providerIdentifier, position }: TrailerPlayerLoaderProps) {
  const {
    data: { data, title, playbackOption },
    isLoading,
  } = usePlay({ platformTitleId, providerIdentifier, isTrailer: true, startSession: false });

  if (isLoading) {
    return <PlayerLoadingSpinner />;
  }

  if (data === undefined) {
    throw new NotFoundError('No stream found');
  }

  if (title === undefined) {
    throw new NotFoundError('No title found');
  }

  if (playbackOption === undefined) {
    throw new NotFoundError('No playback option found');
  }

  return (
    <ErrorBoundary
      fallback={(props) => (
        <PlayerErrorFallback {...props} image={getAggregatedTitleImage(title.masterId, 'wide', 1400)} />
      )}
    >
      <TrailerPlayer data={data} title={title} playbackOption={playbackOption} position={position} />
    </ErrorBoundary>
  );
}
